<template>
<v-layout row wrap>
  <v-flex md2>
    <img :src='profilePhotoUrl' v-if='profilePhotoExistence === true' class="patient--photo">
<patientPhoto v-else></patientPhoto>
  </v-flex>
  <!-- reg form Fields -->
  <v-flex md9 ml-4>
    <el-form :model="reg" :rules="regRules" ref="reg" label-width="120px" class="row wrap" label-position="top" id="registration" inline-message>
      <v-layout row>
        <v-flex md2>
          <el-form-item label="Salutation" prop="select">
            <el-form-item >
              <el-select v-model="reg.select" @change="getSalutation">
                <el-option v-for="salutation in reg.salutations" :key="salutation.value" :label="salutation.label" :value="salutation.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </v-flex md2>
        <v-flex md6>
          <el-form-item label="Full Name" prop="fullname">
            <el-input v-model="reg.fullname" required></el-input>
          </el-form-item>
        </v-flex md6>
                 <v-flex md4>
          <el-form-item label="Select doctor name" prop="doctor_name">
              <el-select v-model="reg.doctor_id" default-first-option @change="getDoctorid(reg.doctor_id)">
                <el-option v-for="item in reg.doctors" :key="item.doctor_id" :label="item.doctor_name" :value="item.doctor_id">
                </el-option>
              </el-select>
          </el-form-item>
        </v-flex md4>
      </v-layout>
      <v-layout row>
        <v-flex md12>
          <el-form-item label="Mobile Number" prop="mobile">
            <el-input v-model="reg.mobile" required></el-input>
          </el-form-item>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex md6>
          <el-form-item label="Gender" prop="gender">
            <el-radio-group v-model="reg.gender" @change="changeSalutation">
              <el-radio label="Male" size="medium">Male</el-radio>
              <el-radio label="Female" size="medium">Female</el-radio>
              <el-radio label="Other" size="medium">Other</el-radio>
            </el-radio-group>
          </el-form-item>
        </v-flex>
        <v-flex md6>
          <el-form-item
          label="Age"
          prop="age"
          >
            <el-input v-model="reg.age" required></el-input>
          </el-form-item>
        </v-flex>
      </v-layout>
      <!-- PLACE -->
      <v-layout row>
        <v-flex md6>
          <el-form-item label="Place (locality)" prop="place">
            <vue-google-autocomplete v-model="reg.place" id="map" classname="form-control" :country="['in']" types="(regions)" v-on:placechanged="getAddressData" >
            </vue-google-autocomplete>
          </el-form-item>
        </v-flex>
        <v-flex md6>
          <el-form-item label="Aadhaar" prop="aadhaar">
            <el-input v-model="reg.aadhaar"></el-input>
          </el-form-item>
        </v-flex>
      </v-layout>
      <!-- AADHAAR -->
      <v-layout row>
        <v-flex md6>
          <el-form-item label="Pick a day" prop="appointmentDate">
            <el-date-picker v-model="reg.appointmentDate" type="date" format="yyyy/M/dd" value-format="yyyy-M-dd" defaultTime='' :picker-options="pickerOptions"
            @change="updateTimePickerMinTime">
            </el-date-picker>
          </el-form-item>
        </v-flex>
        <v-flex md6>
          <el-form-item label="Pick a time" prop="appointmentTime">
            <el-time-picker
            v-model="reg.appointmentTime"
             format="hh:mm A"
             value-format="HH:mm:ss"
             :picker-options="{
              start: '08:30',
              step: '00:15',
              end: '23:45',
              minTime: this.timePickerMinTime
              }">
  </el-time-picker>

          </el-form-item>
        </v-flex>
        <!-- <v-flex md6 v-else-if='this.reg.appointmentDate'>
          <el-form-item label="Pick a time" prop="appointmentTime">
            <el-time-select v-model="reg.appointmentTime" format="HH:mm:ss"   >
  </el-time-select>

          </el-form-item>
        </v-flex> -->
      </v-layout>
      <!-- EMERGENCY NAME -->
      <v-layout row>
        <v-flex md6>
          <el-form-item label="Emergency Contact name " prop="ecyName">
            <el-input v-model="reg.ecyName" required></el-input>
          </el-form-item>
        </v-flex md6>
        <v-flex md6>
          <el-form-item label="Emergency Contact Number" prop="ecyNumber">
            <el-input v-model="reg.ecyNumber" required></el-input>
          </el-form-item>
        </v-flex md6>
      </v-layout>
      <!-- doctor_reference and descriptive_notes -->
      <v-layout row>
        <v-flex md6>
          <el-form-item label="Referred by" prop="doctor_reference">
            <el-input v-model="reg.doctor_reference" required></el-input>
          </el-form-item>
        </v-flex md6>
        <v-flex md6>
          <el-form-item label="Descriptive Notes" prop="descriptive_notes">
            <el-input v-model="reg.descriptive_notes" required></el-input>
          </el-form-item>
        </v-flex md6>
      </v-layout>


      <!-- submit -->
      <!-- <el-button @click="submit">
        submit
      </el-button> -->
      <el-button type="primary" @click="submitForm('reg')">Submit</el-button>
    </el-form>
    <!-- form Fields -->
  </v-flex md9>
</v-layout>
</div>
</template>
<script>
import { api } from "../api.js";
import { axios, get, post } from "axios";
import patientPhoto from "./VueWebcam";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { Notification } from "element-ui";
export default {
  name: "NewRegistration",
  components: {
    patientPhoto,
    VueGoogleAutocomplete
  },
  beforeRouteUpdate: (to, from, next) => {
    console.log("as");
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const newDate = Date.now();
          const onedayOffset = 3600 * 1000 * 24;
          const yesterdayWithOffset = newDate - onedayOffset;
          // return time.getTime() < Date.now();
          return time.getTime() < yesterdayWithOffset;
        }
      },
      hourMins: this.disabledTime,
      timePickerMinTime: "",
      address: "",
      photo: null,
      selectedTab: "tab-1",
      tabs: [
        {
          id: 1,
          name: "ONE"
        },
        {
          id: 2,
          name: "TWO"
        }
      ],
      reg: {
        doctor_id: "",
        doctors: [],
        select: "",
        fullname: "",
        mobile: "",
        gender: "",
        age: null,
        place: "",
        fullAddress: "",
        aadhaar: "",
        appointment: "",
        ecyName: "",
        ecyNumber: "",
        descriptive_notes: "",
        doctor_reference: "",
        appointmentDate: "",
        appointmentTime: "",
        salutations: [
          {
            value: "Mr.",
            label: "Mr."
          },
          {
            value: "Dr.",
            label: "Dr."
          },
          {
            value: "Mrs.",
            label: "Mrs."
          },
          {
            value: "Miss.",
            label: "Miss."
          },
          {
            value: "Ms.",
            label: "Ms."
          },
          {
            value: "Master.",
            label: "Master."
          },
          {
            value: "Baby.",
            label: "Baby."
          },
          {
            value: "Mx.",
            label: "Mx."
          }
        ]
      },
      regRules: {
        select: [
          { required: true, message: "Please select a salutation", trigger: "blur" }
        ],
        doctor_name: [
          { required: false, message: "Please select a doctor name", trigger: "blur" }
        ],

        fullname: [
          { required: true, message: "Please input name", trigger: "blur" },
          { type: "string", message: "Please input text", trigger: "blur" }
        ],
        mobile: [
          {
            required: true,
            message: "Please input mobile number",
            trigger: "blur"
          },
          {
            pattern: /\D*([+][9][1]|[9][1]|[0]){0,1}([6-9]{1})([0-9]{9})\D*/,
            message: "Please enter a valid mobile number",
            trigger: "blur"
          }
          ,
          {
            len: 10,
            message: "Please enter a valid mobile number",
            trigger: "blur"
          }

        ],
        gender: [
          {
            required: true,
            message: "Please select a gender",
            trigger: "change"
          }
        ],
        age: [
          {
            required: true,
            message: "Please input age",
            trigger: "blur"
          },
          {
            pattern: /^([1-9]|[0-9][0-9]|20[0-0])$/,
            message: "Please enter a valid age",
            trigger: "blur"
          }
        ],
        aadhaar: [
          {
            len: 12,
            message: "Please enter a valid 12-digit Aadhaar number",
            trigger: "blur"
          }
        ]
        // place: [
        //   { required: true, message: 'Please enter a place', trigger: 'change' }
        // ],
        // appointmentDate: [
        //   { message: "Please enter a day", trigger: "blur" }
        // ],
        // appointmentTime: [
        //   { message: "Please enter a time", trigger: "blur" }
        // ]
      }
    };
  },
  mounted() {
    this.updateTimePickerMinTime();
    
    if (localStorage.getItem("doctors")) {
      this.reg.doctors=JSON.parse(localStorage.getItem("doctors"))
      this.reg.doctor_id = localStorage.getItem("doctor_id");
      this.fetchDoctorName(this.reg.doctor_id, this.reg.doctors);
    }
  },
  computed: {
    profilePhotoExistence() {
      const pp = localStorage.getItem("profilePhoto");
      if (pp !== "null") return true;
    },
    profilePhotoUrl() {
      const s3url = localStorage.getItem("profilePhoto");
      const splitUrl = s3url.split("?");
      return splitUrl[0];
    },
    disabledTime(time) {
      const newTime = new Date();
      const getHours = newTime.getHours();
      const getMinutes = newTime.getMinutes();
      const hourMins = `${getHours}:${getMinutes}`;
      console.log(hourMins);
      return hourMins;
    },
    getTodayParsedDate() {
      const dt = new Date();
      const fy = dt.getFullYear();
      const fm = Number(dt.getMonth() + 1);
      const fd = Number(dt.getDate());
      const fxxx = `${fy}-${fm}-${fd}`;
      return fxxx;
    }
  },
  methods: {
    fetchDoctorName(doctor_id, doctors) {
      let doc_id = parseInt(doctor_id);
      let arrayDes = doctors;
      let find = arrayDes.find(item => {
        return item.doctor_id === doc_id;
      });
      let res = find.doctor_id;
      this.reg.doctor_id = res;
    },
    updateTimePickerMinTime(date) {
      this.reg.appointmentTime = "";
      let dt = date;
      let minTime = "";

      if (!dt) {
        dt = new Date();
      } else {
        dt = new Date(date);
      }
      const inputYear = dt.getFullYear();
      const inputMonth = Number(dt.getMonth() + 1);
      const inputDate = Number(dt.getDate());
      const inputParsedDate = `${inputYear}-${inputMonth}-${inputDate}`;

      const today = new Date();
      const todayYear = today.getFullYear();
      const todayMonth = Number(today.getMonth() + 1);
      const todayDate = Number(today.getDate());
      const todayParsedDate = `${todayYear}-${todayMonth}-${todayDate}`;

      if (inputParsedDate === todayParsedDate) {
        minTime = `${today.getHours()}:${today.getMinutes()}`;
      }

      console.log(`return → ${minTime}`);

      this.timePickerMinTime = minTime;

      return minTime;
    },
    submitForm(reg) {
      this.$refs[reg].validate(valid => {
        if (valid) {
          console.log("submitting profile...");
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(reg) {
      this.$refs[reg].resetFields();
    },
    getAddressData(addressData, placeResultData, id) {
      this.reg.place = addressData;
      this.reg.fullAddress = placeResultData;
    },
    take_photo() {
      this.photo = this.$refs.webcam.getPhoto();
    },
    getSalutation() {
      const femaleSalutation = ["Miss.", "Ms.", "Mrs.", "Baby."];
      const OtherSalutation = ["Mx."];
      this.reg.gender = femaleSalutation.includes(this.reg.select)
        ? "Female"
        : OtherSalutation.includes(this.reg.select) ? "Other" : "Male";
    },
    getDoctorid(id){
      // this.doctors = JSON.parse(localStorage.getItem("doctors"));
      this.reg.doctor_id = id; 
    },
    changeSalutation() {
      if (this.reg.gender === "Male") {
        this.reg.select = "Mr."
      } else if(this.reg.gender === "Female"){
        this.reg.select = "Ms."
      }
      else {
        this.reg.select = "Mx."
      }
    },
    submit() {
      const newName = this.reg.select + this.reg.fullname;
      const appointmentDateTime =
        this.reg.appointmentDate + " " + this.reg.appointmentTime;
      // let obj = {
      //   basic_info: {
      //     name: newName,
      //     age: this.reg.age,
      //     sex: this.reg.gender,
      //     aadhar: this.reg.aadhaar,
      //     doctor_reference: this.reg.doctor_reference,
      //     descriptive_notes: this.reg.descriptive_notes
      //   },
      //   addresses: [
      //     {
      //       city: this.reg.address
      //     }
      //   ],
      //   phone_number: [
      //     {
      //       name: "",
      //       number: this.reg.mobile
      //     }
      //   ],
      //   emergency: [
      //     {
      //       number: this.reg.ecyNumber,
      //       name: this.reg.ecyName
      //     }
      //   ]
      // };
      let image_id = localStorage.getItem("profilePhotoId");
      let profilePhoto = localStorage.getItem("profilePhoto");
      let reqBody = {
        phone_number: [
          {
            name: "",
            number: this.reg.mobile
          }
        ],
        // doctor_id: this.reg.doctor_id,
        basic_info: {
          name: newName,
          age: this.reg.age,
          aadhar: this.reg.aadhaar,
          doctor_reference: this.reg.doctor_reference,
          descriptive_notes: this.reg.descriptive_notes,
          sex: this.reg.gender
        },
        emergency: [
          {
            name: this.reg.ecyName,
            number: this.reg.ecyNumber
          }
        ],
        addresses: [
          {
            city: this.reg.fullAddress.vicinity,
            address_line: this.reg.fullAddress.formatted_address,
            country: this.reg.place.country,
            state: this.reg.place.administrative_area_level_1
          }

        ],
        image: {
          id: Number(image_id),
          url: profilePhoto
        }
      }
      // var myJSON = JSON.stringify(obj);
      // console.log(myJSON);
      // console.log(appointmentDateTime);
      console.log(reqBody);



      // if appointmentDate and appointmentTime are selected,
      // post patient details & then post appointment
      // else post just patient details
      if (this.reg.appointmentDate != "" && this.reg.appointmentTime != "") {
        post(api + `/v2/registration`, reqBody)
          .then(res => {
            if (res.data.status == true) {
              localStorage.setItem("profilePhoto", null);
              localStorage.setItem("image_id", null);
              post(api +`/appointments?doctor_id=${this.reg.doctor_id}&time=${this.reg.appointmentDate+" "+this.reg.appointmentTime}&place=${this.reg.address}&is_waiting=1&person_id=${res.data.person_id}`).then(res => {
                Notification({
                  title: "Success",
                  message: "Patient profile created",
                  type: "success"
                });
                // this.$router.push("/dashboard");
          let clinic_id = localStorage.getItem("clinic_id");
          let doctor_id = localStorage.getItem("doctor_id");
          this.$router.push("/dashboard/" + clinic_id + "/" + doctor_id);
              })
            } else {
              Notification({
                title: "Error",
                message: "Something went wrong",
                type: "error"
              });
            }

          })

      }
      else {
          post(api + `/v2/registration`, reqBody).then(res => {
            if (res.data.status == true) {
              localStorage.setItem("profilePhoto", null);
              localStorage.setItem("image_id", null);
              Notification({
                title: "Success",
                message: "Patient profile created",
                type: "success"
              });
              // this.$router.push("/dashboard");
          let clinic_id = localStorage.getItem("clinic_id");
          let doctor_id = localStorage.getItem("doctor_id");
          this.$router.push("/dashboard/" + clinic_id + "/" + doctor_id);
            }
            else {
              Notification({
                title: "Error",
                message: "Something went wrong",
                type: "error"
              });
            }

          })
      }
    }
  }
};
</script>
<style scoped>
#registration [class*="md"] {
  margin-right: 0.5rem;
}

#registration .row {
  margin: 0;
}

#map {
  box-shadow: none;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  margin-right: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom: 1px solid #000;
}

.patient--photo {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/NewRegistration.vue